angular.module("app")

.directive("diapleTranslatableField", ['$compile', '$translate', 'LanguagesService', 'logService',
    function ($compile, $translate, LanguagesService, logService) {
        return {
            restrict: 'A',
            replace: true,
            link: function (scope, element, attrs) {

            scope.$watch(attrs["ngModel"], function (value) {
                try {

                    var model: any = scope;

                    var modelNames = attrs["ngModel"].split(".");
                    angular.forEach(modelNames, function (modelName) {
                        if (angular.isUndefined(model[modelName])) {
                            model[modelName] = [];
                        }
                        model = model[modelName];

                    });

                    //asignamos lenguaje por defecto
                    model.selectedLanguageId = $translate.use();
                } catch (e) {
                    //si no encuentra modelos salimos
                    return;
                }

                if (!angular.isUndefined(attrs["diapleTranslatableField"])) {
                    LanguagesService.languages()
                    .then(
                        function (languages) {
                            let html = "<div class='btn-group pull-right'><ul class='nav nav-tabs nav-translation'>";
                            var modelBaseName = attrs["ngModel"];
                            let type = "text"
                            if (!angular.isUndefined(attrs["diapleTranslatableType"])) type = attrs["diapleTranslatableType"];

                            var attributesString = "";
                            if (!angular.isUndefined(attrs["diapleTranslatableAttributes"])) {
                                var attributes = attrs["diapleTranslatableAttributes"].split(",");
                                angular.forEach(attributes, function (att) {
                                    if (att == "required") {
                                        var required = " ng-required=\"";
                                        for (var i = 0; i < languages.length; i++) {
                                            required += "!" + modelBaseName + "[" + i + "]." + attrs["diapleTranslatableField"];
                                            if (i != languages.length - 1) required += " && ";
                                            else required += "\"";
                                        }
                                        attributesString += required;
                                    }
                                    else attributesString += " " + att;
                                });
                            }

                            angular.forEach(languages, function (language, idx) {
                                if (language.code == model.selectedLanguageId) model.selectedLanguage = language.id;
                                html += " <li ng-class=\"{active: " + modelBaseName + ".selectedLanguageId=='" + language.code + "'}\"><a ng-click=\"" + modelBaseName + ".selectedLanguageId='" + language.code + "'; " + modelBaseName + ".selectedLanguage=" + language.id + ";\" data-toggle='tab'>" + language.name + "</a></li>";
                            });

                            html += "</ul></div>";                           

                            angular.forEach(languages, function (language, idx) {

                                //buscamos el lenguaje
                                var modelIdx = null;
                                angular.forEach(model, function (tl, tlIdx) {
                                    if (tl.language_id == language.id) modelIdx = tlIdx;
                                });

                                //si no existia, añadimos objeto vacio para el lenguaje
                                if (modelIdx == null) {
                                    model.push({
                                        language_id: language.id
                                    });
                                    modelIdx = model.length - 1;
                                }

                                var modelName = modelBaseName + "[" + modelIdx + "]." + attrs["diapleTranslatableField"];
                                //logService.debug(modelName, eval(modelName));
                                html += "<div lang='" + language.code + "' ng-show=\"" + modelBaseName + ".selectedLanguageId=='" + language.code + "'\">";
                                if (type == "text") {
                                    html += "<input type='text' class='form-control' ng-model=\"" + modelName + "\" " + attributesString + " />";
                                } else if (type == "textarea") {
                                    html += "<textarea type='text' class='form-control' ng-model=\"" + modelName + "\" " + attributesString + ">" + modelName + "</textarea>";
                                } else if (type == "tinymce") {
                                    html += "<div style='clear:both;'></div><div ui-tinymce='{}' class='form-control' ng-model=\"" + modelName + "\">" + modelName + "</div>";
                                } else if (type == "tinymceCustom") {
                                    html += "<div style='clear:both;'></div><textarea  type='text' ui-tinymce='{resize: true,  force_br_newlines : true, force_p_newlines : false, forced_root_block : \"\", toolbar: \"undo redo bold underlined forecolor\",body_class: \"custom_tinymce_content\",language: \"" + $translate.use().toLowerCase() + "\", plugins: \"textcolor paste\", menubar: false, paste_remove_styles: true,paste_remove_styles_if_webkit: true, paste_strip_class_attributes: true,paste_auto_cleanup_on_paste : true}' class='form-control' ng-model=\"" + modelName + "\">" + modelName + "</textarea>";
                                } else if (type == "tinymceCustomOptions") {
                                    html += "<div style='clear:both;'></div><textarea  type='text' ui-tinymce='" + attrs["diapleTranslatableTinymceOptions"] + "' class='form-control' ng-model=\"" + modelName + "\">" + modelName + "</textarea>";
                                } else {
                                    html += "<input type='text' class='form-control' ng-model=\"" + modelName + "\" " + attributesString + "/> ";
                                }
                                html += "</div>";
                            });
                            html += "";
                            element.html(html);
                            $compile(element.contents())(scope);

                        },
                        function (error) {
                            logService.error(error);
                        }
                    );
                }//if
            });

        }
    };
}])
;